window.dlypopup = function(){
  this.outer = null;
  this.icon = null;
  this.show = function(){
    if (window.dlypopup.icon && window.dlypopup.icon.length) {
      jQuery('.dly-popup').fadeIn();
      window.dlypopup().showIcon();
    }
  };
  this.hide = function(){
    if (window.dlypopup.icon && window.dlypopup.icon.length) {
      jQuery('.dly-popup').fadeOut();
      window.dlypopup().showIcon();
    }
  }
  this.toggle = function(){
    if (window.dlypopup.icon && window.dlypopup.icon.length) {
      jQuery('.dly-popup').fadeToggle();
      window.dlypopup().showIcon();
    }
  };
  this.init = function(outer, icon){
    window.dlypopup.outer = outer;
    window.dlypopup.icon = icon;
    window.dlypopup.outer.show();
  };
  this.showIcon = function(e){
    if (window.dlypopup.icon && window.dlypopup.icon.length) {
      window.dlypopup.icon.fadeIn();
    }
  }
  this.hideIcon = function(e){
    if (window.dlypopup.icon && window.dlypopup.icon.length) {
      window.dlypopup.icon.fadeOut();
    }
  }
  return this;
}
function dlyPopupInit() {
  if (jQuery('.dly-popup-inner').find('.frame').length) {
    window.dlypopup().init(jQuery('.dly-popup-outer'), jQuery('.dly-popup-icon'));
  }
  jQuery('.dly-popup-icon-link').on('click', function(){
    window.dlypopup().toggle();
    return false;
  });
  jQuery('.dly-popup-close-link').on('click', function(){
    window.dlypopup().hide();
    return false;
  });
}

jQuery(document).ready(function () {
  dlyPopupInit();
});
